export enum LoginFlowType {
	Login = 'login',
	Register = 'register',
}

export default LoginFlowType;
